/**
 * The detached lyrics window (2026-10-05): where it opens and what the window
 * is called. One module so the pane that opens it and the page that hosts it
 * cannot disagree; utils/noindexRoutes.js repeats the path as a literal on
 * purpose (it is pinned there by its own test).
 */
export const LYRICS_WINDOW_PATH = '/lyrics-window';
export const LYRICS_WINDOW_NAME = 'cyvLyricsWindow';
